// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm icons:create to update
// Do not edit
import type { SVGProps } from 'react';

export const IconPadlockLockedSvg = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="#373D4C"
      fillRule="evenodd"
      d="M6.801 7.5H13.2c.44 0 .818 0 1.13.025.33.027.657.087.973.247a2.5 2.5 0 0 1 1.092 1.093c.16.315.22.643.247.972.026.313.026.692.026 1.13v3.899c0 .439 0 .818-.026 1.13-.027.33-.086.657-.247.972a2.5 2.5 0 0 1-1.092 1.093c-.316.16-.643.22-.973.247-.312.025-.69.025-1.13.025H6.8c-.439 0-.818 0-1.13-.025-.33-.027-.657-.087-.973-.247a2.5 2.5 0 0 1-1.092-1.093c-.16-.315-.22-.643-.247-.972-.026-.312-.026-.691-.026-1.13v-3.898c0-.44 0-.818.026-1.13.027-.33.086-.658.247-.973a2.5 2.5 0 0 1 1.092-1.093c.316-.16.643-.22.973-.247.312-.025.691-.025 1.13-.025Zm3.199 5a.833.833 0 0 0-.833.833v.834a.833.833 0 0 0 1.666 0v-.834A.833.833 0 0 0 10 12.5ZM6.667 5a3.333 3.333 0 1 1 6.666 0v2.5h-1.666V5a1.667 1.667 0 0 0-3.334 0v2.5H6.667V5Z"
      clipRule="evenodd"
    />
  </svg>
);
